import imgEmptyData from 'assets/images/img_emptyview_no_data.png';
import DropdownTableConfigColumn2 from 'general/components/DropdownTableConfigColumn2';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSButton, {
  KTBSButtonColor,
  KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import KTBSCard from 'general/components/OtherKeenComponents/KTBSCard';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import EmptyView from 'general/components/Others/EmptyView';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

LandownerReconciliationReportListScreen.propTypes = {};

const defaultColumnIds = ['MONTH', 'ENERGY', 'REVENUE', 'COMMISSION', 'CHARGE_TRANSACTION_NO'];

function LandownerReconciliationReportListScreen(props) {
  // ---- params ----
  const { t } = useTranslation();
  const router = useRouter();
  const [filter, setFilter] = useState({
    q: '',
    page: 0,
    limit: AppConfigs.defaultPageLimit,
  });
  const { user } = useSelector((state) => state.auth);
  const fullColumns = useMemo(() => {
    return [
      {
        id: 'MONTH',
        name: (
          <span
            className="letter-spacing-unset font-weight-bolder"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Tháng')}
          </span>
        ),
        selector: (row) => '',
      },
      {
        id: 'ENERGY',
        name: (
          <div className="w-100">
            <div
              className="letter-spacing-unset font-weight-bolder"
              style={{
                fontSize: 12,
                color: AppColors.gray[900],
              }}
            >
              {t('Số điện tiêu thụ')}
            </div>
            <div
              className="letter-spacing-unset font-weight-bold"
              style={{ color: AppColors.gray[700] }}
            >
              {t('kWh')}
            </div>
          </div>
        ),
        selector: (row) => Utils.formatNumber(0),
        width: '180px',
      },
      {
        id: 'REVENUE',
        name: (
          <div className="w-100">
            <div
              className="letter-spacing-unset font-weight-bolder"
              style={{
                fontSize: 12,
                color: AppColors.gray[900],
              }}
            >
              {t('Doanh thu')}
            </div>
            <div
              className="letter-spacing-unset font-weight-bold"
              style={{ color: AppColors.gray[700] }}
            >
              {t('VND')}
            </div>
          </div>
        ),
        selector: (row) => Utils.formatNumber(0),
        width: '180px',
      },
      {
        id: 'COMMISSION',
        name: (
          <div className="w-100">
            <div
              className="letter-spacing-unset font-weight-bolder"
              style={{
                fontSize: 12,
                color: AppColors.gray[900],
              }}
            >
              {t('Hoa hồng')}
            </div>
            <div
              className="letter-spacing-unset font-weight-bold"
              style={{ color: AppColors.gray[700] }}
            >
              {t('%')}
            </div>
          </div>
        ),
        selector: (row) => Utils.formatNumber(0),
        width: '180px',
      },
      {
        id: 'CHARGE_TRANSACTION_NO',
        name: (
          <span
            className="letter-spacing-unset font-weight-bolder"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Số phiên sạc')}
          </span>
        ),
        selector: (row) => '',
      },
    ];
  }, [t]);

  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = router.pathname;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);
  const [fullColumnIds, setFullColumnIds] = useState(
    fullColumns?.map((row) => row?.id).filter(Boolean) || []
  );
  const {
    columnIds,
    columns,
    onChangeCheckboxValue,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumnsSorted,
    fullColumnsIdSorted,
  } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

  // ---- methods ----
  const handleExport = () => { };

  return (
    <div>
      <KTBSCard
        borderRadius="15"
        title={t('Báo cáo đối soát chủ mặt bằng')}
        description={
          <div>
            <span className="font-weight-bolder" style={{ color: AppColors.gray[800] }}>
              {t('total')}:{' '}
            </span>
            <span style={{ color: AppColors.primary }}>
              {20} {t('chủ mặt bằng').toLowerCase()}
            </span>
          </div>
        }
        additionalHeaderClassName="py-4"
        additionalBodyClassName="py-0"
        additionalFooterClassName="py-4"
        hideDividerHeader
        hideDividerFooter
        toolbar={
          <div className="d-flex gap-2">
            <KTBSButton
              color={KTBSButtonColor.primary}
              title={t('exportReport')}
              size={KTBSButtonSize.default}
              borderRadius={5}
              buttonTitleFontWeight="600"
              iconElement={<i className="fa-regular fa-file-export" />}
              onPress={() => { }}
            />
          </div>
        }
        subToolbar={
          <div className="w-100 d-flex align-items-end flex-wrap">
            <div className="col-md-3 col-sm-6 pl-0 py-2">
              <label htmlFor="search" className="mb-0 mr-2 font-weight-bolder">
                {t('search')}
              </label>
              <KTFormSearch
                name="search-bar"
                placeholder={t('typeToSearch')}
                value={filter.q}
                onSubmit={(text) => {
                  setFilter({ ...filter, q: text });
                }}
              />
            </div>
            {/* cau hinh cot */}
            <div className="pr-4 py-2">
              <DropdownTableConfigColumn2
                columnIds={columnIds}
                fullColumns={fullColumns}
                fullColumnIds={fullColumnsIdSorted}
                onChangeCheckboxValue={onChangeCheckboxValue}
                resetDefaultTableColumn={resetDefaultTableColumn}
                onChangeFullColumnIds={(ids) => {
                  setFullColumnIds(ids);
                  const key = prefKey + '_FULL_COLUMN_IDS';
                  localStorage.setItem(key, ids.join('|'));
                }}
                onSelectAll={onSelectAll}
                onUnSelectAll={onUnSelectAll}
              />
            </div>
          </div>
        }
        footer={
          <KTPagination
            currentPage={filter.page + 1}
            rowCount={1}
            rowsPerPage={filter.limit}
            currentItemInPageCount={10}
            onChangePage={(newPage) => {
              const iNewPage = parseInt(newPage);
              setFilter({ ...filter, page: iNewPage - 1 });
            }}
            onChangeRowsPerPage={(newRowsPerPage) => {
              const iNewRowsPerPage = parseInt(newRowsPerPage);
              setFilter({ ...filter, limit: iNewRowsPerPage, page: 0, });
            }}
            loading={false}
            color={KTPaginationColor.success}
          />
        }
        body={
          <div className="">
            <KTTable
              columns={columns}
              items={[{}]}
              selectableRows={false}
              striped={false}
              compactGrid={false}
              onClickedRow={(row) => { }}
              onSelectedRowsChanged={(rows) => { }}
              onDoubleClickedRow={(row) => { }}
              hasActionColumn={false}
              noDataComponent={
                <EmptyView
                  icon={imgEmptyData}
                  title="Không có dữ liệu để hiển thị"
                  text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
                />
              }
            />
          </div>
        }
      />
    </div>
  );
}

export default LandownerReconciliationReportListScreen;
